<template>
  <div class="flex h-full bg-gray-50">
    <Sidebar />
    <div class="flex flex-1 flex-col overflow-hidden">
      <TopBar />
      <main class="flex-1 overflow-y-auto p-4 sm:p-6">
        <RouterView />
      </main>
    </div>
    <!-- Global assistant dock (right side), toggled from the TopBar. -->
    <ChatDock />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import Sidebar from './Sidebar.vue';
import TopBar from './TopBar.vue';
import ChatDock from '../components/chat/ChatDock.vue';
</script>
